import { http } from '@/plugins/http';
import * as TYPE from './mutation-types';
import urlSerialize from '@/utils/urlSerialize';

export const fetchFilter = ({ dispatch }, data) => {
  const paramsString = data.params ? `?${urlSerialize(data.params)}` : '';

  http
    .get(`/filter/${data.type_page}/page/${data.page}/${paramsString}`)
    .then(resp => {
      dispatch('setCountCityCars', resp.data.count_city_cars);
      dispatch('setCountOtherCars', resp.data.count_other_cars);
      dispatch('setLastPage', resp.data.last_page);
      dispatch('setFilterCars', resp.data.cars);
    })
    .catch(error => {
      return Promise.reject({
        error,
      });
    });
};

export const fetchFilterParams = ({ dispatch }, data) => {
  const paramsString = data.params ? `?${urlSerialize(data.params)}` : '';

  http
    .get(`/filter/params/${paramsString}`)
    .then(resp => {
      dispatch('setFilterParams', resp.data);
      dispatch(
        'setWaitForRequestFilterParams',
        data.waitForRequestFilterParams,
      );
    })
    .catch(error => {
      return Promise.reject({
        error,
      });
    });
};

export const setCountCityCars = ({ commit }, value) =>
  commit(TYPE.COUNT_CITY_CARS, value);
export const setCountOtherCars = ({ commit }, value) =>
  commit(TYPE.COUNT_OTHER_CARS, value);
export const setLastPage = ({ commit }, value) => commit(TYPE.LAST_PAGE, value);
export const setFilterCars = ({ commit }, value) =>
  commit(TYPE.FILTER_CARS, value);
export const setFilterParams = ({ commit }, value) =>
  commit(TYPE.FILTER_PARAMS, value);
export const setWaitForRequestFilterParams = ({ commit }, value) =>
  commit(TYPE.WAIT_FOR_REQUEST_FILTER_PARAMS, value);
